import React from 'react';
import cn from 'classnames';

const Body = ({ children, className }) => {
  return <div className={cn('page-body', className)}>{children}</div>;
};

export default Body;
